import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import React from 'react';
import { layouts } from '@/layouts';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { pageRoutes } from '@/routes/routes';
const routes = {};
pageRoutes.forEach(pageRoute => {
  if (pageRoute.enable) {
    const layout = pageRoute.layout || 'BasicLayout';
    const route = {
      path: pageRoute.path,
      element: pageRoute.element,
      errorElement: /*#__PURE__*/React.createElement(_Spin, null)
    };

    if (routes[layout]) {
      routes[layout].children.push(route);
    } else {
      routes[layout] = {
        element: layouts[layout],
        children: [route]
      };
    }
  }
});
const router = createBrowserRouter(Object.values(routes));
export const ReactRouterProvider = () => /*#__PURE__*/React.createElement(RouterProvider, {
  router: router,
  fallbackElement: /*#__PURE__*/React.createElement(_Spin, null)
});